var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 0.90918H5.45457C2.94419 0.90918 0.909119 2.94425 0.909119 5.45463V14.5455C0.909119 17.0559 2.94419 19.091 5.45457 19.091H14.5455C17.0559 19.091 19.0909 17.0559 19.0909 14.5455V5.45463C19.0909 2.94425 17.0559 0.90918 14.5455 0.90918Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 9.42719C13.7485 10.1838 13.6193 10.9565 13.267 11.6354C12.9148 12.3143 12.3574 12.8648 11.6742 13.2087C10.991 13.5526 10.2168 13.6723 9.46161 13.5508C8.70647 13.4293 8.00886 13.0727 7.46802 12.5319C6.92719 11.991 6.57065 11.2934 6.44914 10.5383C6.32763 9.78315 6.44732 9.00891 6.79119 8.32571C7.13507 7.64251 7.68561 7.08514 8.36452 6.73287C9.04343 6.38059 9.81613 6.25136 10.5727 6.36356C11.3445 6.478 12.0589 6.83761 12.6106 7.38929C13.1623 7.94096 13.5219 8.65544 13.6364 9.42719Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5H15.01",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.088b76d2c201e592e55103a7bb158414.svg";
export { ForwardRef as ReactComponent };